import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type GetRenderedLineTextOptions = CommonRequestOptions & {
   raw_text: string;
};

export type GetRenderedLineTextResult = {
   html: string;
};

export async function getRenderedLineText({
   raw_text,
   ...common
}: GetRenderedLineTextOptions): Promise<GetRenderedLineTextResult> {
   return makeRequest('post', `guides/steps/lines/preview`, {
      body: {
         raw: raw_text,
      },
      ...common,
   });
}
